import React from 'react';
import Mobile from './Mobile/ConfiguratorMobile';
import Desktop from './Desktop/ConfiguratorDesktop';

export default function CarType({ step, index, onClickSelectType, onClickStep }) {
  const stepSelectedItem = step?.items?.find((item) => item.selected);
  return (
    <>
      <Desktop
        stepSelectedItem={stepSelectedItem}
        step={step}
        index={index}
        onClickSelectType={onClickSelectType}
        onClickStep={onClickStep}
      />
      <Mobile
        stepSelectedItem={stepSelectedItem}
        step={step}
        index={index}
        onClickSelectType={onClickSelectType}
        onClickStep={onClickStep}
      />
    </>
  );
}
